<template>
	<van-skeleton avatar :row="1" v-if="List.length==0">{{List.length}}</van-skeleton>
    <div  v-else class="votesrecord-body">
      <div class="votesrecord-body-item" v-for="(item,index) in List" :key="index">
      	<!-- <div class="votesrecord-body-item-info">
      		<div class="votesrecord-body-item-info-name">
      			<div>NO.{{index+1}}</div>
      			<div>{{item.name}}</div>
      		</div>
      		<div class="votesrecord-body-item-info-new">
      			<div v-if="item.rank>0">排名：<span>{{item.rank}}</span></div>
      			<div>票数：<span>{{item.votes}}</span></div>
      		</div>
      	</div> -->
      	<div class="votesrecord-body-item-content">
      		<div class="votesrecord-body-item-content-title">{{item.title}}</div>
            <MyVideo :id="'video'+index" class="mwap_video"  :src="item.mediaurl" :poster="item.mediaurl|videoposter2"></MyVideo>
			     <!-- <img :src="item.mediaurl+'?x-oss-process=video/snapshot,t_5000,f_jpg,w_750,h_431,ar_auto'" slot="icon" alt="" @click="gotouch(item)"> -->
      	</div>
      </div>
    </div>
</template>
<script>
    import {Popup,Tab, Tabs} from 'vant'
    import MyVideo from '@/components/mVideo/index'
    import './index.less'

    export default {
        name: "myvotes",
        components: {
            vanTab:Tab,
            vanTabs:Tabs,
            vanPopup:Popup,
            MyVideo
        },
        props:{
            List:Array
        },
        data() {
            return {
            }
        },
        methods: {
            gotouch(item) {
            	this.$emit('gotouch',item);
            }
        }
    }
</script>
